export default __webpack_public_path__ + "static/media/astkaave.57b04453.svg";